import { MasterType } from '../context/MasterContextProvider';
import { ApiClient } from './ApiClient';

export type MasterApiType = MasterType | null;

export const MasterApi = async (): Promise<MasterApiType> => {
  try {
    const response = await ApiClient.get<MasterApiType>('master');
    const message = response.data;
    return message;
  } catch (err) {
    // pass
  }

  return null;
};
